<div class="row">
  <div class="col-12 text-center">
    <img src="../../../../assets/img//logo2-cace-sf.png" width="150" height="150" alt="">
  </div>
</div>
<div class="row mt-4">
  <div class="col-12">
    <span>
      <b><h5>Résumé du document</h5></b>
      Le terme ainsi que l'obligation ont pour point commun de reposer tous deux sur des événements futurs, ils sont donc des modalités temporelles de l'obligation. La distinction entre ces modalités est fine, mais belle est bien existante.
    </span>
  </div>

  <div class="col-12 mt-4">
    <span>
      <b><h6>1. Préambule</h6></b>
      En effet, le terme est un évènement futur qui influe sur l'exigibilité de l'obligation, quant à la condition elle influe sur l'existence de l'obligation.
    </span>
  </div>

  <div class="col-12 mt-4">
    <span>
      <b><h6>2. Article 1</h6></b>
      Le Code civil s'est montré lacunaire en cette matière, aucune définition du terme n'était présente, ce n'est que lors de la réforme des obligations que le législateur a remédié à cette carence en introduisant l'article 1305 dans le Code civil qui prévoit que "l'obligation est à terme lorsque son exigibilité est différée jusqu'à la survenance d'un événement futur et certain, encore que la date en soit incertaine" ainsi que l'article 1304 qui prévoit que "l'obligation est conditionnelle lorsqu'elle dépend d'un événement futur et incertain."
    </span>
  </div>

  <div class="col-12 mt-4">
    <span>
      <b><h6>3. Article 2</h6></b>
    Aucune définition du terme n'était présente, ce n'est que lors de la réforme des obligations que le législateur a remédié à cette carence en introduisant l'article 1305 dans le Code civil
    </span>
  </div>
</div>

<div class="row mt-4">
  <div class="col-12">
    <p-checkbox [(ngModel)]="confirm" [binary]="true" label="Lu et approuvé les conditions de l'offre" inputId="binary"></p-checkbox>
    <!-- <p-checkbox name="groupname" [value]="confirm" label="J'accepte les conditions de l'offre" [(ngModel)]="confirm"></p-checkbox> -->
    <!-- <div class="field-checkbox">
      <p-checkbox name="group" [value]="confirm" [(ngModel)]="confirm" inputId="confirm"></p-checkbox>
      <label for="confirm">J'accepte les conditions de l'offre</label>
    </div> -->
  </div>
</div>

<div class="row mt-3 justify-content-center">
  <div class="col-12 col-md-6">
    <button type="submit" [disabled]="!confirm" (click)="accepted()">J'accepte et j'ajoute l'offre</button>
  </div>
</div>